import React__default from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  children: PropTypes.node.isRequired,
  legend: PropTypes.node.isRequired,
  horizontalAlignment: PropTypes.oneOf(['center', 'left', 'right']),
  layout: PropTypes.oneOf(['', '2-up', '3-up', '4-up', '5-up', '6-up']),
  theme: PropTypes.oneOf(['default', 'inverse']),
  verticalAlignment: PropTypes.oneOf(['bottom', 'middle', 'top'])
};
function SizeTileGroup(_ref) {
  var children = _ref.children,
    horizontalAlignment = _ref.horizontalAlignment,
    layout = _ref.layout,
    legend = _ref.legend,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'default' : _ref$theme,
    verticalAlignment = _ref.verticalAlignment;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "size-tile-group",
    "data-horizontal-alignment": horizontalAlignment,
    "data-layout": layout,
    "data-testid": "size-tile-group",
    "data-theme": theme,
    "data-vertical-alignment": verticalAlignment
  }, /*#__PURE__*/React__default.createElement("fieldset", null, /*#__PURE__*/React__default.createElement("legend", {
    className: "h4"
  }, legend), /*#__PURE__*/React__default.createElement("div", {
    className: "sitg-input-outer-wrapper",
    "data-testid": "sitg-input-outer-wrapper"
  }, children)));
}
SizeTileGroup.propTypes = propTypes;

export { SizeTileGroup as default };
//# sourceMappingURL=SizeTileGroup.js.map
